/**
 * @module  Income Free
 */
import {getField, updateField} from 'vuex-map-fields';
import {mixin} from "../../helpers/helper";

export default {
  mixins: [mixin],
  namespaced: true,
  state: {
    trans: {},
    inputs_1: [],
    inputs_2: [],
    inputs_3: [],
    showModalConfigure: false,
    formData: [],
    id: 0,
    type: 0,
    customId: 0,
    mappedBuilding: [],
    saveOk: false,
    avoidRefresh: false,
    showHideModalRating: false,
    personalInvestment: [],
    rating: {
      storeModule: 'customfree',
      questionRate: '<strong>Valuta</strong> la gestione del Conto Economico',
      section: 'Conto Economico Mercato Libero',
      showHideModalRating: false,
    },
    exportLink: '',
    modalConfigureKey: 0,
    agency_val_1: 0,
    agency_val_2: 0,
    agency_val_3: 0,
    agency_val_4: 0,
    agency_sell_val_1: 0,
    agency_sell_val_2: 0,
    agency_sell_val_3: 0,
    agency_sell_val_4: 0,
    idToDelete: 0,
    cessione: 0,
    thisId: 0,
		isSaving: false,
		formDataLoaded: false
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,

    setData: function (state, data) {
      eval("state." + data.name + " = data.data;");
    },

    saveOkSet: function (state, boolean) {
      state.saveOk = boolean;
    },
    initPropsSet: function (state, data) {
      state.id = data.id;
      state.type = data.type;
      state.customId = data.customId;
    },
    buildingDetailSet: function (state, data) {
      state.mappedBuilding = data;
    },
    showModalConfigureSet: function (state) {
      state.modalConfigureKey += 1;
      state.showModalConfigure = !state.showModalConfigure;
    },

    customFreeSet: function (state, data) {
      state.thisId = data.customData.id;
      state.formData.percentage_estate_1 = data.customData.percentuale_agenzia_1;
      state.formData.percentage_estate_2 = data.customData.percentuale_agenzia_2;
      state.formData.percentage_estate_3 = data.customData.percentuale_agenzia_3;
      state.formData.percentage_estate_4 = data.customData.percentuale_agenzia_4;
      state.formData.percentage_estate_sell_1 = data.customData.percentuale_agenzia_vendita_1;
      state.formData.percentage_estate_sell_2 = data.customData.percentuale_agenzia_vendita_2;
      state.formData.percentage_estate_sell_3 = data.customData.percentuale_agenzia_vendita_3;
      state.formData.percentage_estate_sell_4 = data.customData.percentuale_agenzia_vendita_4;
      state.formData.fixed_estate_1 = data.customData.fisso_agenzia_1;
      state.formData.fixed_estate_2 = data.customData.fisso_agenzia_2;
      state.formData.fixed_estate_3 = data.customData.fisso_agenzia_3;
      state.formData.fixed_estate_4 = data.customData.fisso_agenzia_4;
      state.formData.fixed_estate_sell_1 = data.customData.fisso_agenzia_vendita_1;
      state.formData.fixed_estate_sell_2 = data.customData.fisso_agenzia_vendita_2;
      state.formData.fixed_estate_sell_3 = data.customData.fisso_agenzia_vendita_3;
      state.formData.fixed_estate_sell_4 = data.customData.fisso_agenzia_vendita_4;
      state.formData.estate_type = data.customData.tipo_agenzia;
      state.formData.estate_sell_type = data.customData.tipo_agenzia_vendita;
      state.formData.substitutiveTax_1 = data.customData.percentuale_imposta_sostitutiva_1;
      state.formData.substitutiveTax_2 = data.customData.percentuale_imposta_sostitutiva_2;
      state.formData.substitutiveTax_3 = data.customData.percentuale_imposta_sostitutiva_3;
      state.formData.substitutiveTax_4 = data.customData.percentuale_imposta_sostitutiva_4;
      state.formData.percentage_tax_1 = data.customData.percentuale_tassa_1;
      state.formData.percentage_tax_2 = data.customData.percentuale_tassa_2;
      state.formData.percentage_tax_3 = data.customData.percentuale_tassa_3;
      state.formData.percentage_tax_4 = data.customData.percentuale_tassa_4;
      state.formData.percentuale_tassa_registro_1 = data.customData.percentuale_tassa_registro_1;
      state.formData.rendita_catastale_1 = data.customData.rendita_catastale_1;
      state.formData.rendita_catastale_2 = data.customData.rendita_catastale_2;
      state.formData.rendita_catastale_3 = data.customData.rendita_catastale_3;
      state.formData.rendita_catastale_4 = data.customData.rendita_catastale_4;
      state.formData.numero_casa = data.customData.numero_casa;
      state.formData.costi_4 = data.customData.costi_4;
      state.formData.costi_4_totale_finanziamento = data.customData.costi_4_totale_finanziamento;
      state.formData.costi_4_totale = data.customData.costi_4_totale;
      state.formData.costi_4_mq = data.customData.costi_4_mq;
      state.formData.costi_4_mq_tasse = data.customData.costi_4_mq_tasse;
      state.formData.ricavi_4_mq = data.customData.ricavi_4_mq;
      state.formData.utile_4_lordo = data.customData.utile_4_lordo;
      state.formData.totale_4_tasse = data.customData.totale_4_tasse;
      state.formData.utile_4_netto = data.customData.utile_4_netto;
      state.personalInvestment.scenario_1 = data.customData.capitale_proprio;
      state.personalInvestment.scenario_2 = data.customData.capitale_proprio_2;
      state.personalInvestment.scenario_3 = data.customData.capitale_proprio_3;
      state.personalInvestment.scenario_4 = data.customData.capitale_proprio_4;

      state.agency_val_1 = data.customData.fisso_agenzia_1;
      state.agency_val_2 = data.customData.fisso_agenzia_2;
      state.agency_val_3 = data.customData.fisso_agenzia_3;
      state.agency_val_4 = data.customData.fisso_agenzia_4;

      state.agency_sell_val_1 = data.customData.fisso_agenzia_vendita_1;
      state.agency_sell_val_2 = data.customData.fisso_agenzia_vendita_2;
      state.agency_sell_val_3 = data.customData.fisso_agenzia_vendita_3;
      state.agency_sell_val_4 = data.customData.fisso_agenzia_vendita_4;

      state.inputs_1 = data.customFieldList.filter(function (item) {
        return item.blocco === 1;
      });
      state.inputs_2 = data.customFieldList.filter(function (item) {
        return item.blocco === 2;
      });
      state.inputs_3 = data.customFieldList.filter(function (item) {
        return item.blocco === 3;
      });

      state.formData.cessione = data.customData.cessione;
    },

    defaultCustomFreeSet: function (state) {
      state.formData.percentage_estate_1 = "2.0";
      state.formData.percentage_estate_2 = "2.0";
      state.formData.percentage_estate_3 = "2.0";
      state.formData.percentage_estate_4 = "2.0";
      state.formData.fixed_estate_1 = "0.0";
      state.formData.fixed_estate_2 = "0.0";
      state.formData.fixed_estate_3 = "0.0";
      state.formData.fixed_estate_4 = "0.0";
      state.formData.percentage_estate_sell_1 = "0.0";
      state.formData.percentage_estate_sell_2 = "0.0";
      state.formData.percentage_estate_sell_3 = "0.0";
      state.formData.percentage_estate_sell_4 = "0.0";
      state.formData.fixed_estate_sell_1 = "0.0";
      state.formData.fixed_estate_sell_2 = "0.0";
      state.formData.fixed_estate_sell_3 = "0.0";
      state.formData.fixed_estate_sell_4 = "0.0";
      state.formData.estate_type = 1;
      state.formData.estate_sell_type = 1;
      state.formData.substitutiveTax_1 = "0.2";
      state.formData.substitutiveTax_2 = "0.2";
      state.formData.substitutiveTax_3 = "0.2";
      state.formData.substitutiveTax_4 = "0.2";
      state.formData.percentage_tax_1 = "26.0";
      state.formData.percentage_tax_2 = "26.0";
      state.formData.percentage_tax_3 = "26.0";
      state.formData.percentage_tax_4 = "26.0";
      state.formData.rendita_catastale_1 = "0";
      state.formData.rendita_catastale_2 = "0";
      state.formData.rendita_catastale_3 = "0";
      state.formData.rendita_catastale_4 = "0";
      state.formData.numero_casa = 1;
      state.formData.percentuale_tassa_registro_1 = "9.0";
      state.inputs_1 = [];
      state.inputs_2 = [];
      state.inputs_3 = [];

      // ref: the field is blocked and edited. We use it to generate further amount
      // codice: the field is blocked and readonly. we use it to create a manual row with automatism (ex. 100 * 0.25)

      state.inputs_1.push(
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_acquisto'),
          blocco: 1,
          opzionale: 0,
          ref: 1,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_atto_acquisto'),
          blocco: 1,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_agenzia_acquisto'),
          blocco: 1,
          opzionale: 0,
          ref: 0,
          codice: 'agenzia'
        },

        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta:window.root.$t('custom.label_agenzia_vendita'),
          blocco: 1,
          opzionale: 1,
          ref: 0,
          // codice: 'agenzia_vendita'
          codice: ''
        },

        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_tassa_registro'),
          blocco: 1,
          opzionale: 0,
          ref: 0,
          codice: 'tassa_registro'
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_architetto'),
          blocco: 1,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_condono'),
          blocco: 1,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_spese_condominiali'),
          blocco: 1,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: 'Home Staging',
          blocco: 1,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_fatture_luce'),
          blocco: 1,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_imprevisti'),
          blocco: 1,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_costo_ristrutturazione'),
          blocco: 1,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
      );

      state.inputs_2.push(
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_valore_finanziamento'),
          blocco: 2,
          opzionale: 0,
          ref: 1,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_notaio'),
          blocco: 2,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_costi_gestione'),
          blocco: 2,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_perito'),
          blocco: 2,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_spesa_istruttoria'),
          blocco: 2,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_imposta_sostitutiva'),
          blocco: 2,
          opzionale: 1,
          ref: 0,
          codice: 'impostaSostitutiva'
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_assicurazione'),
          blocco: 2,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_interessi_mesi'),
          blocco: 2,
          opzionale: 1,
          ref: 0,
          codice: ''
        },
      );

      state.inputs_3.push(
        {
          importo_1: 0,
          importo_2: 0,
          importo_3: 0,
          importo_4: 0,
          etichetta: window.root.$t('custom.label_totale_ricavi'),
          blocco: 3,
          opzionale: 0,
          ref: 1,
          codice: ''
        },
      );

    },
  },
  actions: {

    initCustomFree: function (state, data) {
      state.commit('initPropsSet', data);
      state.dispatch('retrieveCustomFreeData');
    },


    retrieveCustomFreeData: function (state) {
      if (state.state.customId != undefined) {
        axios.get('/api/v1/custom/retrieveCustomFreeData/' + state.state.customId)
          .then(function (response) {
            if (response.data.customFieldList.length === 0) {
              state.commit('defaultCustomFreeSet');
            } else {
              state.commit('customFreeSet', response.data);
            }

						state.commit('setData', {name: 'formDataLoaded', data: true});
          });
      }
    },

    sendData: function (state) {
      axios.post('/api/v1/custom/SendCustomFreeData', {
        cessione: state.state.formData.cessione,
        customId: state.state.customId,
        customFields_1: state.state.inputs_1,
        customFields_2: state.state.inputs_2,
        customFields_3: state.state.inputs_3,
        percentage_estate_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_1),
        percentage_estate_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_2),
        percentage_estate_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_3),
        percentage_estate_4: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_4),
        fixed_estate_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.fixed_estate_1),
        fixed_estate_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.fixed_estate_2),
        fixed_estate_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.fixed_estate_3),
        fixed_estate_4: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.fixed_estate_4),
        estate_type: state.state.formData.estate_type,
        percentage_estate_sell_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_sell_1),
        percentage_estate_sell_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_sell_2),
        percentage_estate_sell_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_sell_3),
        percentage_estate_sell_4: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_sell_4),
        fixed_estate_sell_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.fixed_estate_sell_1),
        fixed_estate_sell_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.fixed_estate_sell_2),
        fixed_estate_sell_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.fixed_estate_sell_3),
        fixed_estate_sell_4: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.fixed_estate_sell_4),
        estate_sell_type: state.state.formData.estate_sell_type,
        substitutiveTax_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.substitutiveTax_1),
        substitutiveTax_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.substitutiveTax_2),
        substitutiveTax_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.substitutiveTax_3),
        substitutiveTax_4: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.substitutiveTax_4),
        percentage_tax_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_tax_1),
        percentage_tax_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_tax_2),
        percentage_tax_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_tax_3),
        percentage_tax_4: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_tax_4),
        percentuale_tassa_registro_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentuale_tassa_registro_1),
        rendita_catastale_1: mixin.methods.REMOVE_DOT(state.state.formData.rendita_catastale_1),
        rendita_catastale_2: mixin.methods.REMOVE_DOT(state.state.formData.rendita_catastale_2),
        rendita_catastale_3: mixin.methods.REMOVE_DOT(state.state.formData.rendita_catastale_3),
        rendita_catastale_4: mixin.methods.REMOVE_DOT(state.state.formData.rendita_catastale_4),
        numero_casa: state.state.formData.numero_casa,
        costi_4: mixin.methods.REMOVE_DOT(state.state.formData.costi_4),
        costi_4_totale_finanziamento: mixin.methods.REMOVE_DOT(state.state.formData.costi_4_totale_finanziamento),
        costi_4_totale: mixin.methods.REMOVE_DOT(state.state.formData.costi_4_totale),
        costi_4_mq: mixin.methods.REMOVE_DOT(state.state.formData.costi_4_mq),
        costi_4_mq_tasse: mixin.methods.REMOVE_DOT(state.state.formData.costi_4_mq_tasse),
        ricavi_4_mq: mixin.methods.REMOVE_DOT(state.state.formData.ricavi_4_mq),
        utile_4_lordo: mixin.methods.REMOVE_DOT(state.state.formData.utile_4_lordo),
        totale_4_tasse: mixin.methods.REMOVE_DOT(state.state.formData.totale_4_tasse),
        utile_4_netto: mixin.methods.REMOVE_DOT(state.state.formData.utile_4_netto),
        capitale_proprio: mixin.methods.REMOVE_DOT(state.state.personalInvestment.scenario_1),
        capitale_proprio_2: mixin.methods.REMOVE_DOT(state.state.personalInvestment.scenario_2),
        capitale_proprio_3: mixin.methods.REMOVE_DOT(state.state.personalInvestment.scenario_3),
        capitale_proprio_4: mixin.methods.REMOVE_DOT(state.state.personalInvestment.scenario_4),
      })
        .then(response => {
          //state.commit('showModalConfigureSet');
					state.commit('setData', {name: 'isSaving', data: false});
          state.commit('saveOkSet', true);
          state.dispatch('offMsg');



          state.commit('setData', {name: 'thisId', data: response.data.thisId});

          if(state.state.avoidRefresh === true)
          {
            // do nothing
          }
          else{
            window.location.href ='/custom/' + state.state.id + '/' + state.state.customId;
          }

          if (state.state.exportLink.length > 0) {
            window.location.href = state.state.exportLink;
            state.commit('setData', {name: 'exportLink', data: ''});
          }
        })
        .catch(function (error) {

        });

    },

    /**
     * Used to show "saved" label everywhere
     * @param state
     */
    offMsg: function (state, data) {
      setTimeout(function () {
        state.commit('saveOkSet', false);
      }, 2000);
    },

    openCloseRatingModal: function (state) {

      axios.post('/api/v1/rating/checkRatingDone', {
        area: state.state.rating.section
      })
        .then(function (response) {
          if (response.data === false) {
            state.state.rating.showHideModalRating = !state.state.rating.showHideModalRating;
          } else {
            state.state.rating.showHideModalRating = false;
          }


        })
        .catch(function (error) {

        })

    },

    deleteCustom: function (state) {
      axios.get('/api/v1/custom/delete/' + state.state.idToDelete)
        .then(response => {
          window.location.href = '/dashboard'
        })
    }
  }
}
